import { AbstractControl, ValidatorFn, Validators } from '@angular/forms';

export class NumberValidator {

    static number(decimalsAmount?: number): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null => {
            const regExp = new RegExp(`^\\d+(\\.(\\d{1,${decimalsAmount || 999}})?)?$`); // Acepta ej: "20."
            // const regExp = new RegExp(`^\\d+(\\.\\d{1,${decimalsAmount || 999}})?$`);
            if (control.value && !regExp.test(control.value)) {
                let msg = 'El valor debe ser un número';
                if (decimalsAmount) {
                    msg += ` con ${decimalsAmount} decimales máximo`;
                }
                return { 'number': { msg: msg } };
            }

            return null;
        };
    }

    static integer(control: AbstractControl): { [key: string]: any } | null {
        return !control.value || /^\d+$/.test(control.value) ?
            null :
            { 'integer': { msg: 'El valor debe ser un número entero' } };
    }

    static alpha(control: AbstractControl): { [key: string]: any } | null {
        return !control.value || /^([^0-9]*)$/.test(control.value) ?
            null :
            { 'alpha': { msg: 'El valor debe contener solo letras' } };
    }

    static startZero(control: AbstractControl): { [key: string]: any } | null {
        return !control.value || /^[1-9]\d*$/.test(control.value) ?
            null :
            { 'startZero': { msg: 'No puede comenzar con cero' } };
    }
    static numberMax(control: AbstractControl): { [key: string]: any } | null {
        return !control.value || /^([0-9]){9}$/.test(control.value) ?
            null :
            { 'numberMax': { msg: 'Máximo invalido' } };
    }

    static validRUT(control: AbstractControl): { [key: string]: any } | null {
        return !control.value || /^[1-9]\d{1,7}[-][0-9kK]{1}$/.test(control.value) ?
            null : { 'validRUT': { msg: 'Ingrese un RUT válido' } };
    }

    static range(min?: number, max?: number): ValidatorFn {
        return (c: AbstractControl): { [key: string]: any } | null => {
            if (isNaN(c.value)
                || (min !== undefined && c.value < min)
                || (max !== undefined && c.value > max)) {
                let msg: string;
                if (min !== undefined && max !== undefined) {
                    msg = `El valor debe estar entre ${min} y ${max}`;
                } else if (min !== undefined) {
                    msg = `El valor no puede ser menor que ${min}`;
                } else {
                    msg = `El valor no puede ser mayor que ${max}`;
                }

                return {
                    'range': { msg: msg }
                };
            }
            return null;
        };
    }

    static greaterThan(value: number): ValidatorFn {
        return (c: AbstractControl): { [key: string]: any } | null => {
            if (isNaN(c.value) || (c.value <= value)) {
                return {
                    'min': { msg: `El valor debe ser mayor que ${value}` }
                };
            }
            return null;
        };
    }

    static lowerThan(value: number): ValidatorFn {
        return (c: AbstractControl): { [key: string]: any } | null => {
            if (isNaN(c.value) || (c.value >= value)) {
                return {
                    'min': { msg: `El valor debe ser menor que ${value}` }
                };
            }
            return null;
        };
    }

    static equalThan(value: number): ValidatorFn {
        return (c: AbstractControl): { [key: string]: any } | null => {
            if (isNaN(c.value) || (c.value === value)) {
                return {
                    'min': { msg: `El valor debe ser igual que ${value}` }
                };
            }
            return null;
        };
    }

    static validDocFormat(country: string): ValidatorFn {

        const pattern = /^[0-9]{1,12}$/;
        // const pattern = /^(?=[a-zA-Z]{0,3}[0-9]{1,4}).{1,4}-[a-zA-Z0-9]{1,8}$/;

        return (c: AbstractControl): { [key: string]: any } | null => {
          console.log({ value: c.value })
            if ((!c.value || !pattern.test(c.value))/*&& country === 'PE'*/ ) {
                return {
                    'number': { msg: 'Formato incorrecto' }
                };
            }
            return null;
        };


    }

}
